import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TicketList, User, Ticket } from '../_shared/models';
import {
  AuthenticationService,
  TicketService,
  LoadingService
} from '../_shared/services';
import { Granule } from '../config';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: [
    '../../assets/css/core-navbar.css',
    '../../assets/css/core-scrollbar.css',
    '../ticket/_css-ticket/ticket-content.css',
    '../ticket/ticket-list/ticket-list.component.css',
    '../ticket/ticket-detail/ticket-detail.component.css',
    '../ticket/ticket-item/ticket-item.component.css',
    './dashboard.component.css'
  ]
})
export class DashboardComponent implements OnInit {
  private user: User;
  private replyTickets: Array<Ticket>;
  private myTickets: Array<Ticket>;
  private urgentTickets: Array<Ticket>;
  private warningTickets: Array<Ticket>;
  private isReplyTicketLoaded: boolean = false;
  private isMyTicketLoaded: boolean = false;
  private isUrgentTicketLoaded: boolean = false;
  private storageProfileUrl = this.granule.CMS_ROUTE_STORAGE_USER;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private ticketService: TicketService,
    private loadingService: LoadingService,
    private granule: Granule
  ) {}

  ngOnInit() {
    // redirect to legal agreement page if first time logging in
    this.authenticationService.isFirstTime.subscribe(value => {
      if (value) {
        this.router.navigate(['/legalagreement']);
      }
    });

    // get selected role
    this.authenticationService.userInfo.subscribe(userInfo => {
      this.user = userInfo;
      this.getMyTickets();
    });
    this.load(false);
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  getMyTickets() {
    this.ticketService
      .getMyTickets(
        this.user.current_role.division_id,
        this.user.current_role.role_id,
        null,
        null
      )
      .finally(() => {
        this.isReplyTicketLoaded = true;
        this.isMyTicketLoaded = true;
        this.isUrgentTicketLoaded = true;
        console.log(this.myTickets);
        let dateNow = new Date();
        let dateNowMinusTwo = dateNow;
        dateNowMinusTwo.setDate(dateNow.getDate() - 2);
        this.urgentTickets = this.myTickets.filter(
          t => t.taken_by == null && new Date(t.updated_at) > dateNowMinusTwo
        );
        this.replyTickets = this.myTickets.filter(
          t => t.last_replied_by == this.user._id
        );
      })
      .subscribe(res => {
        this.myTickets = res.data.tickets;
      });
  }

  navigateTo(ticket_id: string) {
    this.router.navigate(['/ticketing/mytickets/detail/' + ticket_id]);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/dashboard/dashboard.component.ts